export default "__VITE_ASSET__DEJ7UoAl__"